if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

      this.hideErrors = this.dataset.hideErrors === 'true';
    }

    /**
     * Get current variant data from the page
     */
    getCurrentVariant() {
      const variantInput = this.form.querySelector('input[name="id"]');
      if (!variantInput) return null;
      
      const variantId = parseInt(variantInput.value);
      const variantData = this.getVariantData();
      
      return variantData.find(v => v.id === variantId) || null;
    }

    /**
     * Get all variant data from the page
     */
    getVariantData() {
      const variantSelector = document.querySelector('variant-radios, variant-selects');
      if (!variantSelector) return [];
      
      const jsonScript = variantSelector.querySelector('[type="application/json"]');
      if (!jsonScript) return [];
      
      try {
        return JSON.parse(jsonScript.textContent);
      } catch (e) {
        return [];
      }
    }

    /**
     * Check if variant is "In doos" (unassembled) type
     */
    isUnassembledVariant(variant) {
      if (!variant || !variant.options) return false;
      
      const unassembledNames = ['in doos', 'in box', 'doos', 'niet gemonteerd', 'ongemonteerd'];
      
      return variant.options.some(option => {
        const lowerOption = option.toLowerCase().trim();
        return unassembledNames.some(name => lowerOption === name || lowerOption.includes(name));
      });
    }

    /**
     * Check if variant is "Rijklaar" (assembled) type
     */
    isAssembledVariant(variant) {
      if (!variant || !variant.options) return false;
      
      const assembledNames = ['gemonteerd', 'assembled', 'montage', 'rijklaar'];
      
      return variant.options.some(option => {
        const lowerOption = option.toLowerCase().trim();
        return assembledNames.some(name => lowerOption === name || lowerOption.includes(name));
      });
    }

    /**
     * Check if any accessories are selected
     */
    hasSelectedAccessories() {
      return window.dynamicPrice && window.dynamicPrice.selectedOptions.size > 0;
    }

    /**
     * Check if product has accessories available
     */
    hasAccessoriesAvailable() {
      const accessoryCards = document.querySelectorAll('.extra-option-card');
      return accessoryCards.length > 0;
    }

    /**
     * Check if the product has assembly options (has both assembled and unassembled variants)
     */
    hasAssemblyOptions() {
      const variantData = this.getVariantData();
      console.log('ProductForm: hasAssemblyOptions - variantData length:', variantData.length);
      
      if (!variantData.length) {
        console.log('ProductForm: No variant data found');
        return false;
      }
      
      const assembledNames = ['gemonteerd', 'assembled', 'montage', 'rijklaar'];
      const unassembledNames = ['in doos', 'in box', 'doos', 'niet gemonteerd', 'ongemonteerd'];
      
      let hasAssembled = false;
      let hasUnassembled = false;
      let foundOptions = [];
      
      variantData.forEach(variant => {
        if (!variant.options) return;
        
        variant.options.forEach(option => {
          const lowerOption = option.toLowerCase().trim();
          if (!foundOptions.includes(lowerOption)) {
            foundOptions.push(lowerOption);
          }
          if (assembledNames.some(name => lowerOption === name || lowerOption.includes(name))) {
            hasAssembled = true;
          }
          if (unassembledNames.some(name => lowerOption === name || lowerOption.includes(name))) {
            hasUnassembled = true;
          }
        });
      });
      
      console.log('ProductForm: Found options:', foundOptions);
      console.log('ProductForm: hasAssembled:', hasAssembled, 'hasUnassembled:', hasUnassembled);
      
      return hasAssembled && hasUnassembled;
    }

    /**
     * Get product info for the popup
     */
    getProductInfo() {
      // Try multiple selectors to find product info
      const productSection = this.closest('.product') || this.closest('[class*="product"]') || document;
      const info = {
        title: '',
        vendor: '',
        image: '',
        extras: ''
      };
      
      // Get product title - try multiple selectors
      const titleEl = document.querySelector('.product__title h1') || 
                     document.querySelector('.product__title') ||
                     document.querySelector('h1.h2') ||
                     document.querySelector('[class*="product"] h1');
      if (titleEl) {
        info.title = titleEl.textContent.trim();
      }
      
      // Get vendor - try multiple selectors
      const vendorEl = document.querySelector('.product__text a') || 
                      document.querySelector('.product__vendor') ||
                      document.querySelector('[class*="vendor"]');
      if (vendorEl) {
        info.vendor = vendorEl.textContent.trim();
      }
      
      // Get product image - try multiple selectors
      const imageEl = document.querySelector('.product__media-item--active img') ||
                     document.querySelector('.product__media-item img') ||
                     document.querySelector('.product__media img') ||
                     document.querySelector('.swiper-slide-active img');
      if (imageEl) {
        info.image = imageEl.src;
      }
      
      // Get extras text
      if (window.getProductExtrasText) {
        info.extras = window.getProductExtrasText();
      }
      
      return info;
    }

    async onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      // Check if we need to show the assembly popup
      const currentVariant = this.getCurrentVariant();
      const variantData = this.getVariantData();
      
      console.log('ProductForm: Checking assembly popup condition...');
      console.log('ProductForm: currentVariant:', currentVariant);
      console.log('ProductForm: hasAssemblyOptions:', this.hasAssemblyOptions());
      console.log('ProductForm: isUnassembledVariant:', currentVariant ? this.isUnassembledVariant(currentVariant) : false);
      console.log('ProductForm: isAssembledVariant:', currentVariant ? this.isAssembledVariant(currentVariant) : false);
      console.log('ProductForm: hasSelectedAccessories:', this.hasSelectedAccessories());
      console.log('ProductForm: hasAccessoriesAvailable:', this.hasAccessoriesAvailable());
      
      // Determine which popup mode to show
      let popupMode = null;
      
      // Case 1: "In doos" variant selected - show assembly popup
      if (this.hasAssemblyOptions() && this.isUnassembledVariant(currentVariant)) {
        popupMode = 'assembly';
      }
      // Case 2: "Rijklaar" variant selected without accessories - show accessory confirmation popup
      else if (this.isAssembledVariant(currentVariant) && !this.hasSelectedAccessories() && this.hasAccessoriesAvailable()) {
        popupMode = 'accessory';
      }
      
      if (popupMode) {
        // Show popup instead of adding to cart
        const assemblyPopup = document.querySelector('assembly-popup');
        console.log('ProductForm: Assembly popup element found:', !!assemblyPopup);
        console.log('ProductForm: Popup mode:', popupMode);
        
        if (assemblyPopup && typeof assemblyPopup.show === 'function') {
          const productInfo = this.getProductInfo();
          console.log('ProductForm: Showing popup with info:', productInfo);
          
          assemblyPopup.show({
            productForm: this,
            formData: new FormData(this.form),
            variantData: variantData,
            currentVariant: currentVariant,
            productInfo: productInfo,
            mode: popupMode
          });
          
          return; // Don't proceed with normal add to cart
        } else if (assemblyPopup) {
          // Element exists but custom element not yet upgraded - wait a bit and try again
          console.log('ProductForm: Waiting for assembly-popup to be upgraded...');
          await customElements.whenDefined('assembly-popup');
          const productInfo = this.getProductInfo();
          
          assemblyPopup.show({
            productForm: this,
            formData: new FormData(this.form),
            variantData: variantData,
            currentVariant: currentVariant,
            productInfo: productInfo,
            mode: popupMode
          });
          
          return;
        } else {
          console.warn('ProductForm: assembly-popup element not found in DOM');
        }
      }

    this.submitButton.setAttribute('aria-disabled', true);
    this.submitButton.classList.add('loading');
    
    // Change button text to loading state
    const buttonSpan = this.submitButton.querySelector('span');
    if (buttonSpan) {
      this.originalButtonText = buttonSpan.textContent;
      buttonSpan.textContent = 'Wordt toegevoegd...';
    }

      const formData = new FormData(this.form);
      
      // Collect extra options with linked products (variant IDs)
      let extraItems = [];
      
      console.log('ProductForm: Checking dynamicPrice...');
      console.log('ProductForm: window.dynamicPrice exists:', !!window.dynamicPrice);
      
      if (window.dynamicPrice) {
        console.log('ProductForm: selectedOptions size:', window.dynamicPrice.selectedOptions.size);
        console.log('ProductForm: selectedOptions Map:', Array.from(window.dynamicPrice.selectedOptions.entries()));
      }
      
      if (window.dynamicPrice && window.dynamicPrice.selectedOptions.size > 0) {
        const selectedOptions = window.dynamicPrice.getSelectedOptions();
        console.log('ProductForm: Adding extra options to cart:', selectedOptions);

        let extraOptionIndex = 0;
        selectedOptions.forEach((option) => {
          // Skip bundle-included items - they are part of the bundle product, not separate cart items
          if (option.bundleIncluded) {
            console.log(`ProductForm: Skipping bundle-included option: ${option.title || option.id}`);
            formData.append(`properties[Inbegrepen: ${option.title || option.id}]`, 'Inbegrepen in bundel');
            return;
          }

          extraOptionIndex++;
          console.log(`ProductForm: Processing extra option ${extraOptionIndex}:`, option);

          // Add option title as property to main item (use title for display, fallback to id)
          formData.append(`properties[Extra Option ${extraOptionIndex}]`, option.title || option.id);
          formData.append(`properties[_Extra Option ${extraOptionIndex} Price]`, (option.price / 100).toFixed(2));

          // If linked product exists, add to extra items queue
          if (option.variantId) {
            console.log(`ProductForm: Option ${extraOptionIndex} has variantId:`, option.variantId);
            extraItems.push({
              id: option.variantId,
              quantity: 1
            });
          } else {
            console.log(`ProductForm: Option ${extraOptionIndex} has NO variantId`);
          }
        });

        // Add total extra options price property (exclude bundle-included items)
        const extraOptionsTotal = selectedOptions
          .filter(opt => !opt.bundleIncluded)
          .reduce((sum, opt) => sum + opt.price, 0);
        formData.append('properties[_Extra Options Total]', (extraOptionsTotal / 100).toFixed(2));
      }

      // Check if insurance checkbox is selected
      console.log('ProductForm: Checking insurance checkbox...');
      console.log('ProductForm: window.insuranceCheckbox exists:', !!window.insuranceCheckbox);
      
      if (window.insuranceCheckbox) {
        const isSelected = window.insuranceCheckbox.isSelected();
        console.log('ProductForm: Insurance is selected:', isSelected);
        
        if (isSelected) {
          const insuranceVariantId = window.insuranceCheckbox.getVariantId();
          console.log('ProductForm: Insurance variant ID:', insuranceVariantId);
          
          if (insuranceVariantId) {
            extraItems.push({
              id: insuranceVariantId,
              quantity: 1
            });
            formData.append('properties[_Insurance Added]', 'true');
            console.log('ProductForm: Added insurance product to extraItems:', insuranceVariantId);
          } else {
            console.warn('ProductForm: Insurance selected but no variant ID found!');
          }
        }
      } else {
        console.log('ProductForm: No insurance checkbox on this page');
      }

      try {
        // First, add the main product
        const mainConfig = fetchConfig('javascript');
        mainConfig.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete mainConfig.headers['Content-Type'];
        
        if (this.cart) {
          formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        mainConfig.body = formData;

        let mainResponse = await fetch(`${routes.cart_add_url}`, mainConfig);
        let mainResult = await mainResponse.json();
        
        if (mainResult.status) {
          publish(PUB_SUB_EVENTS.cartError, {source: 'product-form', productVariantId: formData.get('id'), errors: mainResult.description, message: mainResult.message});
          this.handleErrorMessage(mainResult.description);

          const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
          if (!soldOutMessage) return;
          this.submitButton.setAttribute('aria-disabled', true);
          this.submitButton.querySelector('span').classList.add('hidden');
          soldOutMessage.classList.remove('hidden');
          this.error = true;
          return;
        }

        // Now add extra option products one by one
        let lastResponse = mainResult;
        
        console.log('ProductForm: Extra items to add:', extraItems);
        console.log('ProductForm: Number of extra items:', extraItems.length);
        
        for (const extraItem of extraItems) {
          console.log('ProductForm: Adding extra item:', extraItem);
          const extraConfig = fetchConfig('javascript');
          extraConfig.headers['X-Requested-With'] = 'XMLHttpRequest';
          extraConfig.headers['Content-Type'] = 'application/json';
          
          const sections = this.cart ? this.cart.getSectionsToRender().map((section) => section.id) : [];
          
          extraConfig.body = JSON.stringify({
            id: Number(extraItem.id),
            quantity: extraItem.quantity,
            sections: sections,
            sections_url: window.location.pathname
          });

          const extraResponse = await fetch(`${routes.cart_add_url}`, extraConfig);
          const extraResult = await extraResponse.json();
          
          if (extraResult.status) {
            console.warn('Failed to add extra option to cart:', extraResult.description);
            // Continue with other items even if one fails
          } else {
            lastResponse = extraResult;
          }
        }

        if (!this.cart) {
          window.location = window.routes.cart_url;
          return;
        }

        if (!this.error) publish(PUB_SUB_EVENTS.cartUpdate, {source: 'product-form', productVariantId: formData.get('id')});
        this.error = false;
        
        const quickAddModal = this.closest('quick-add-modal');
        if (quickAddModal) {
          document.body.addEventListener('modalClosed', () => {
            setTimeout(() => { this.cart.renderContents(lastResponse) });
          }, { once: true });
          quickAddModal.hide(true);
        } else {
          this.cart.renderContents(lastResponse);
        }
      } catch(e) {
        console.error('Error adding to cart:', e);
    } finally {
      this.submitButton.classList.remove('loading');
      if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
      if (!this.error) this.submitButton.removeAttribute('aria-disabled');
      
      // Restore original button text
      const buttonSpan = this.submitButton.querySelector('span');
      if (buttonSpan && this.originalButtonText) {
        buttonSpan.textContent = this.originalButtonText;
      }
    }
    }

    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;

      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
